export const isEncodedURI = (str: string) => {
  try {
    const decoded = decodeURIComponent(str);
    return decoded !== str;
  } catch (e) {
    return false;
  }
};

export const generateDeepLink = (_resourceId: string, deepLinkCommentId: string) => {
  const resourceId = isEncodedURI(_resourceId) ? _resourceId : encodeURIComponent(_resourceId);

  return [
    window?.location.origin ?? '',
    window?.location.pathname ?? '',
    `?resourceId=${resourceId}&commentId=${deepLinkCommentId}`,
  ].join('');
};
